import React from "react";

export function KpiCard({ label, value, sub, tone = "default", testid }) {
  const toneMap = {
    default: "text-foreground",
    accent: "text-accent",
    success: "text-emerald-600 dark:text-emerald-400",
    warning: "text-amber-600 dark:text-amber-400",
    danger: "text-red-600 dark:text-red-400",
  };
  return (
    <div className="rounded-xl border border-border bg-card p-5 sm:p-6 shadow-sm" data-testid={testid}>
      <p className="section-label">{label}</p>
      <p className={`kpi-value mt-2 ${toneMap[tone]}`}>{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}
